import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import { alpha, styled } from '@mui/material/styles'

export const ItemContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2.5),
  paddingRight: theme.spacing(1.5),
  paddingLeft: theme.spacing(1.5),
  position: 'relative',
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
  '&:focus': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '-2px',
  },
  '&:focus:not(:focus-visible)': {
    outline: 'none',
  },
}))

export const NotificationContent = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  position: 'relative',
}))

export const NotificationText = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}))

export const TopRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: '12px',
}))

export const IndicatorsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  position: 'absolute',
  top: 0,
  right: 0,
  cursor: 'pointer',
  padding: '4px',
  borderRadius: '4px',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}))

export const UnreadIndicator = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: theme.palette.success.main,
}))

export const TimeStampRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '14px',
}))

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 36,
  height: 36,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontSize: '0.875rem',
  flexShrink: 0,
}))

export const IconContainer = styled(Box)<{ bgcolor: string }>(
  ({ bgcolor }) => ({
    width: 36,
    height: 36,
    borderRadius: '50%',
    backgroundColor: bgcolor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  })
)
